import React from "react"

const embed = (link, aspect_ratio) => {
  var pattern, match, position
  var patterns = [
    {
      regex: /youtu\.be\/([\w\-.]+)/,
      type: "youtube",
      url: "https://www.youtube.com/embed/%1",
    },
    {
      regex: /youtube\.com(.+)v=([^&]+)/,
      type: "youtube",
      url: "https://www.youtube.com/embed/%2",
    },
    {
      regex: /vimeo\.com\/([0-9]+)/,
      type: "vimeo",
      url: "https://player.vimeo.com/video/%1",
    },
    {
      regex: /vimeo\.com\/(.*)\/([0-9]+)/,
      type: "vimeo",
      url: "https://player.vimeo.com/video/%2",
    },
  ]

  var type = ""
  var url = ""

  /*
    var embed_html = '';
    var prepend = '';
    var append = '';
    
    if (typeof aspect_ratio != undefined) {
      var percent_ratio = Math.round(100*100/aspect_ratio)/100;
      prepend = '<div style="padding-bottom:'+percent_ratio+'%;position:relative;width:100%;height:0;overflow:hidden;">';
      append = '</div>';
    }
    */

  for (var i = 0; i < patterns.length; i++) {
    pattern = patterns[i]

    if ((match = link.match(pattern.regex))) {
      position = pattern.url.match(/%([0-9]+)/)[1]
      type = pattern.type
      url = pattern.url.replace(/%([0-9]+)/, match[position])
    }
  }

  return url
}

export default ({ videoLink, style, background }) => (
  <iframe
    title="video"
    src={
      embed(videoLink) +
      `?title=0&byline=0&portrait=0&loop=1&autoplay=1&autopause=0&background=${
        background ? "1" : "0"
      }&muted=${background ? "1" : "0"}`
    }
    style={{ borderStyle: "none", overflow: "hidden", ...style }}
  />
)
